var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"competitor-score-status",attrs:{"data-state":_vm.state,"data-automatic":_vm.automatic}},[_c('span',{attrs:{"title":_vm.statusName}},[_vm._v(_vm._s(_vm.statusShortname))]),_c('el-input-number',{attrs:{"type":"text","controls-position":"right","value":_vm.value,"size":"mini"},on:{"change":_vm.changeScore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }